<template>
  <div>
    <!-- Primary Page Layout
    ==================================================-->

    <div class="section big-55-height over-hide z-bigger">
      <div class="parallax parallax-top" style="background-image: url('img/1.jpg')"></div>
      <div class="dark-over-pages"></div>

      <div class="hero-center-section pages">
        <div class="container">
          <div class="row justify-content-center">
            <div class="col-12 parallax-fade-top">
              <div class="hero-text">Search</div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="section book-toolbar-details">
      <div class="container">
        <div class="row">
          <div class="col-lg-6 text-left">
            <div>
              <h6>
                <b>Dates</b>
              </h6>
            </div>
            <span>{{ userQuery.checkIn }} - {{ userQuery.checkOut }}</span>
          </div>
          <div class="col-lg-6 text-left">
            <div>
              <h6>
                <b>Rooms & Guests</b>
              </h6>
            </div>
            <span>1 Room : {{ userQuery.guests }} Guests</span>
          </div>
        </div>
      </div>
    </div>

    <div class="section padding-top-bottom z-bigger">
      <div class="section z-bigger">
        <div class="container">
          <div class="row">
            <div class="col-lg-12">
              <div class="row bg-light" :class="{'mb-4': i !== rooms.length}" v-for="(room, i) in rooms" :key="room.roomTypeCode">
                <div class="col-lg-6 p-0">
                  <div class="room-name">{{ room.roomName }}</div>
                  <img :src="room.image" alt style="width: 100%; height: 100%">
                </div>

                <div class="col-lg-6  align-self-center">
                  <div class="row px-4">
                    <div class="col-lg-12">
                      <h4>{{ room.roomName }}</h4>
                      <br>
                      <div class="row p-4">
                        <table class="table">
                          <thead class="bg-dark text-white">
                            <tr>
                              <th>Rate</th>
                              <th>Price/Night</th>
                              <th>Action</th>
                            </tr>
                          </thead>
                          <tbody>
                            <tr v-for="rate in room.rates" :key="rate.ratePlanCode">
                              <th>{{ rate.ratePlanName }}</th>
                              <th>${{ rate.rateCost }}</th>
                              <th><button class="btn btn-success btn-sm" @click="selectRoom($event, room.roomTypeCode, rate.ratePlanCode)">Select</button></th>
                            </tr>
                          </tbody>
                        </table>
                        <!-- <div class="col-md-4"> Name</div>
                        <div class="col-md-4">Rate Price</div>
                        <div class="col-md-4">Rate Price</div> -->
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- Modal -->
    <div
      class="modal fade"
      id="ratingDetails"
      tabindex="-1"
      role="dialog"
      aria-labelledby="exampleModalLabel"
      aria-hidden="true"
    >
      <div class="modal-dialog" role="document">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title" id="exampleModalLabel">
              Rate Details
              <span style="font-size: 14px">Regular Rate</span>
            </h5>
            <button type="button" class="close" data-dismiss="modal" aria-label="Close">
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div class="modal-body">
            <h6>Holding Your Reservation</h6>
            <p>Your reservation is not guaranteed if you arrive late. Please note that your room will only be guaranteed until 6:00 PM on the day of your expected arrival.</p>

            <div class="alert alert-light" role="alert">
              <h6>Cancelling Your Reservation</h6>
              <p>
                You may cancel your reservation for no charge until 4:00 PM hotel time on March 26, 2019.
                Please note that we will assess a fee of 206.01 USD if you must cancel after this deadline. If you have made a prepayment, we will retain all or part of your prepayment. If not, we will charge your credit card.
              </p>
            </div>

            <h6>Modifying Your Reservation</h6>
            <p>Please note that a change in the length or dates of your reservation may result in a rate change.</p>
          </div>
          <div class="modal-footer">
            <button type="button" class="btn btn-secondary" data-dismiss="modal">Close</button>
            <!-- <button type="button" class="btn btn-primary">Save changes</button> -->
          </div>
        </div>
      </div>
    </div>

    <div
      class="modal fade"
      id="roomDetails"
      tabindex="-1"
      role="dialog"
      aria-labelledby="roomDetails"
      aria-hidden="true"
    >
      <div class="modal-dialog" role="document">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title">
              Room Details
              <span style="font-size: 14px">{{ room.category_name }}</span>
            </h5>
            <button type="button" class="close" data-dismiss="modal" aria-label="Close">
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div class="modal-body">
            <div class="owl-carousel">
              <div v-for="i in 5">
                <div
                  style="background-image: url(http://localhost:8080/img/room3.jpg)"
                  class="sliderElem"
                ></div>
              </div>
            </div>
            <h6>Deluxe Room - City View</h6>
            <span>Room images may not correspond to the actual room received.</span>

            <div class="row mt-4">
              <div class="col-lg-4" v-for="feature in room.roomFeatures" :key="feature.id">
                <div class="mb-4">
                  <h6>
                    <b>{{ feature.name }}</b>
                  </h6>
                  <p v-for="featureValue in feature.value" :key="featureValue">{{ featureValue }}</p>
                </div>
              </div>
              <!-- <div class="col-lg-4">
                <div class="mb-4">
                  <h6>
                    <b>Room Overview</b>
                  </h6>
                  <p>Deluxe King</p>
                </div>
                <div class="mb-4">
                  <h6>
                    <b>Special Benefits</b>
                  </h6>
                  <p>Business services, for a fee</p>
                  <p>expanded a la carte menu (for purchase)</p>

                  <p>evening bar service</p>
                </div>
                <div class="mb-4">
                  <h6>
                    <b>Beds and Bedding</b>
                  </h6>
                  <p>Maximum Occupancy: 3</p>
                  <p>1 King</p>
                  <p>Rollaway beds not permitted</p>
                  <p>Cribs not permitted</p>
                  <p>Pillowtop mattress, and Duvet</p>
                </div>

                <div class="mb-4">
                  <h6>
                    <b>Room Features</b>
                  </h6>
                  <p>32sqm/344sqft</p>
                  <p>This room is non-smoking</p>
                  <p>Connecting rooms are available (for some rooms)</p>
                </div>
              </div>
              <div class="col-lg-4">
                <div class="mb-4">
                  <h6>
                    <b>Room Overview</b>
                  </h6>
                  <p>Deluxe King</p>
                </div>
                <div class="mb-4">
                  <h6>
                    <b>Special Benefits</b>
                  </h6>
                  <p>Business services, for a fee</p>
                  <p>expanded a la carte menu (for purchase)</p>

                  <p>evening bar service</p>
                </div>
                <div class="mb-4">
                  <h6>
                    <b>Beds and Bedding</b>
                  </h6>
                  <p>Maximum Occupancy: 3</p>
                  <p>1 King</p>
                  <p>Rollaway beds not permitted</p>
                  <p>Cribs not permitted</p>
                  <p>Pillowtop mattress, and Duvet</p>
                </div>

                <div class="mb-4">
                  <h6>
                    <b>Room Features</b>
                  </h6>
                  <p>32sqm/344sqft</p>
                  <p>This room is non-smoking</p>
                  <p>Connecting rooms are available (for some rooms)</p>
                </div>
              </div>
              <div class="col-lg-4">
                <div class="mb-4">
                  <h6>
                    <b>Room Overview</b>
                  </h6>
                  <p>Deluxe King</p>
                </div>
                <div class="mb-4">
                  <h6>
                    <b>Special Benefits</b>
                  </h6>
                  <p>Business services, for a fee</p>
                  <p>expanded a la carte menu (for purchase)</p>

                  <p>evening bar service</p>
                </div>
                <div class="mb-4">
                  <h6>
                    <b>Beds and Bedding</b>
                  </h6>
                  <p>Maximum Occupancy: 3</p>
                  <p>1 King</p>
                  <p>Rollaway beds not permitted</p>
                  <p>Cribs not permitted</p>
                  <p>Pillowtop mattress, and Duvet</p>
                </div>

                <div class="mb-4">
                  <h6>
                    <b>Room Features</b>
                  </h6>
                  <p>32sqm/344sqft</p>
                  <p>This room is non-smoking</p>
                  <p>Connecting rooms are available (for some rooms)</p>
                </div>
              </div> -->
            </div>
          </div>
          <div class="modal-footer">
            <button type="button" class="btn btn-secondary" data-dismiss="modal">Close</button>
            <!-- <button type="button" class="btn btn-primary">Save changes</button> -->
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "search",
  data(){
      return{
        userQuery: {},
        rooms:{},
        room:{},
        rate:{}

      }
  },
  mounted() {
    $(".owl-carousel").owlCarousel({
      margin: 10,
      items: 1,
      loop: true,
      mouseDrag: true,
      autoWidth: true
    });

    if(localStorage.queryData && localStorage.rooms){
      this.userQuery = JSON.parse(localStorage.queryData)
      this.rooms = JSON.parse(localStorage.rooms)


    }else{
      this.$router.push('/');
    }
  },
  methods:{
    viewDetails(id){
      this.room = this.rooms.find(obj => obj.id == id);
    },

    selectRoom($event, roomTypeCode, ratePlanCode){
      this.room = this.rooms[roomTypeCode];
      this.rate = this.room.rates[ratePlanCode];

      localStorage.room = JSON.stringify(this.room);
      localStorage.rate = JSON.stringify(this.rate);
      localStorage.queryData = JSON.stringify(this.userQuery);
      localStorage.requestDetails = '';
      this.$router.push('book-details');

    }
  }
};
</script>

<style>
.sliderElem {
  height: 300px;
  background-position: center center;
  border-radius: 4px;
}

.modal-header h5 {
  font-weight: bold;
  display: inline;
}
</style>

